import { useLingui } from '@lingui/react/macro';
import { ChevronDown } from '@remarkable/ark-icons';
import { Typography } from '@remarkable/ark-web';
import { useState } from 'react';
import { type Integration } from 'src/api/endpoints/cloudApi.types';
import { formatDate } from 'src/utils/formatDate';
import { twJoin } from 'tailwind-merge';
import { getProviderDisplayName } from '../utils/getProviderDisplayName';
import { getPrimaryIssue } from '../utils/integrationIssues';
import { getIssueCopy, IntegrationStatus } from './IntegrationStatus';

export const MobileIntegrationDetailsRow = ({
  integration,
}: {
  integration: Integration;
}) => {
  const { i18n } = useLingui();
  const [isExpanded, setIsExpanded] = useState(false);
  const issue = getPrimaryIssue(integration);
  return (
    <div className="flex flex-col flex-nowrap gap-0">
      <Typography
        variant="body-sm"
        className="flex flex-wrap items-center gap-4"
      >
        <span>{getProviderDisplayName(integration.provider)}</span>
        <span className="flex items-center gap-4">
          | {formatDate(integration.added, { locale: i18n.locale })}
        </span>
        <span className="flex items-center gap-4">
          |
          {issue ? (
            <button
              type="button"
              onClick={() => setIsExpanded((expanded) => !expanded)}
              aria-expanded={isExpanded}
              className="flex items-center gap-4"
            >
              <IntegrationStatus issues={integration.issues} />
              <ChevronDown
                size={18}
                className={twJoin(
                  'transition-transform duration-200',
                  isExpanded ? 'rotate-180' : '-translate-y-px'
                )}
              />
            </button>
          ) : (
            <IntegrationStatus issues={integration.issues} />
          )}
        </span>
      </Typography>
      {isExpanded && issue && (
        <Typography
          variant="body-sm"
          italic
          className="animate-fade-in-down-short text-interaction-danger"
        >
          {getIssueCopy(issue)}
        </Typography>
      )}
    </div>
  );
};
